import React from 'react'
import { Box } from '@mui/material'
import { LandingNav } from './LandingNav'
import { LandingHero } from './LandingHero'
import { LandingSections } from './LandingSections'
import { LandingFinale } from './LandingFinale'

/**
 * Landing v2 — the editorial, asymmetric marketing page built on the
 * Spectrum design-system tokens and components.
 *
 * Mounted at `/` via LandingV2Layout, which owns the auth-redirect and
 * `/auth?step=` dialog wiring.
 */
export function LandingV2Page() {
  return (
    <Box sx={{ background: 'var(--ds-canvas)', color: 'var(--ds-ink)', overflowX: 'hidden' }}>
      <LandingNav />
      <LandingHero />
      <LandingSections />
      <LandingFinale />
    </Box>
  )
}

export default LandingV2Page
